"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoIframeUrl = getVideoIframeUrl;
exports.useFormatUrlMethods = void 0;
var _gemDomainUtils = require("./gemDomainUtils");
var _gemUrlFormatUtils = require("./gemUrlFormatUtils");
function getVideoIframeUrl(options = {}) {
  const domainInfos = (options === null || options === void 0 ? void 0 : options.domains) || (0, _gemDomainUtils.getDomainInfos)();
  const videoIframeUrl = `https://${domainInfos.QCMAIN_HOST}/solution-new/tc-video`;
  return videoIframeUrl;
}
const useFormatUrlMethods = () => {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)();
  return (0, _gemUrlFormatUtils.getFormatUrlMethods)({
    domains
  });
};
exports.useFormatUrlMethods = useFormatUrlMethods;